import { CodeBase } from "./_codeBase";

/** 設定範囲区分*/
export class SettingRangeDiv extends CodeBase<SettingRangeDiv>
{
    /** 設定範囲区分: "01", "全ユーザ"*/
    public static readonly ALL: SettingRangeDiv= new SettingRangeDiv("01", "全ユーザ", "");
    /** 設定範囲区分: "02", "会社"*/
    public static readonly COMPANY: SettingRangeDiv= new SettingRangeDiv("02", "会社", "");
    /** 設定範囲区分: "03", "個人"*/
    public static readonly INDIVIDUAL: SettingRangeDiv= new SettingRangeDiv("03", "個人", "");


    /**
    * 
    * @param value
    * @param text
    */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): SettingRangeDiv[] {
        return [
            SettingRangeDiv.ALL,
            SettingRangeDiv.COMPANY,
            SettingRangeDiv.INDIVIDUAL,
        ];
    }
}
